/* eslint-disable */
import React from 'react'

import ContentHeader from '../../containers/ContentHeader'
import PageTab from '../../components/PageTab'
import PageTabs from '../../components/PageTabs'
import EcgLoader from '../../containers/EcgLoader'
import {
  SETTINGS_PAGE_TABS,
  TABLE_HEADER_HEIGHT,
  HEADER_HEIGHT,
  BOTTOM_PADDING,
  getPermissionOptions,
  CUSTOM_TRIGGER_DEFAULT,
  ALL_RECORDINGS_TRIGGER_OPTION,
  TRIAGE_OPTION,
  PRIMARY_TRIGGER_TYPES,
  TRIGGER_FREQUENCY_TYPES,
  getPrimaryTriggerOption,
  CUSTOM_TRIGGER_OPTION,
  TRIGGER_TYPES,
} from '../../constants'
import { TeamInvitesTable, TeamMembersTable } from '../../containers/Tables'
import styles from './Settings.css'
import { needToBustCache } from '../../store/appReducer'
import { checkRpmFeatureEnabled } from 'configs/index'
import { NewMemberForm, UpdatePasswordForm, InboxSettingsForm, TeamSettingsForm } from '../../containers/Forms'
import { checkTKFeatureEnabled } from '../../../configs'

const TEAM_INVITES_ROW_HEIGHT = 50
class Settings extends React.Component {
  state = {
    innerHeight: 0,
    // innerWidth: 0,
  }
  UNSAFE_componentWillMount() {
    const {
      dataLastUpdated,
      getSettingsData,
      getTeamMemberFileData,
    } = this.props
    getSettingsData(needToBustCache(dataLastUpdated))
    getTeamMemberFileData(needToBustCache(dataLastUpdated))
    window.addEventListener('resize', this.handleResize)
    this.setState({
      innerHeight: window.innerHeight,
      // innerWidth: window.innerWidth,
    })
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }


  handleResize = () => {
    this.setState({
      innerHeight: window.innerHeight,
      // innerWidth: window.innerWidth,
    })
  }

  render() {
    const {
      dataIsFetching,
      dataLastUpdated,
      handleOnRefreshClick,
      refreshClicked,
      bulkActionComplete,
      bulkActionIsFetching,
      getSettingsData,
      selectedIndex,
      selectedPageTab,
      selectedPopover,
      handleOnTabClick,
      handleOnInviteSubmit,
      handleOnFilterButtonClick,
      handleOnSelectionClick,
      teamInvitesIds,
      selectedTeamInvites,
      selectedTeamInvitesEmail,
      updateSelectedTeamInvites,
      teamInvitesSortBy,
      teamInvitesSortDirection,
      handleOnTeamInvitesFilterChange,
      handleOnTeamInvitesSortClick,
      handleOnTeamInvitesBulkAction,
      teamMembersIds,
      teamMembersSortBy,
      teamMembersSortDirection,
      selectedTeamMembers,
      selectedTeamMembersId,
      selectedTeamMembersEmail,
      selectedTeamMembersAdminPermissionId,
      selectedTeamMembersPhysicianPermissionId,
      updateSelectedTeamMembers,
      handleOnTeamMembersFilterChange,
      handleOnTeamMembersSortClick,
      handleOnTeamMemberRowClick,
      me,
      teamInvites: teamInvitesDataSource,
      physicians: physiciansDataSource,
      teamTriggers: teamTriggersDataSource,
      pwError,
      pwErrorMsg,
      pwIsFetching,
      validationTests,
      handleUpdatePasswordChange,
      handleAppointmentNotificationsChange,
      handleOnEditTeamMemberSubmit,
      getAppointmentNotificationsSettings,
      submitUpdatePassword,
      handleInboxSettingsForm,
      inboxSettingsFormData,
      inboxSettingsFormPristine,
      handleOnEditTeamMember,
      getTeamMemberFileData,
      memberOnChangeInfo,
      memberInfo,
      inviteMemberFormValues,
    } = this.props
    const {
      innerHeight,
    } = this.state

    const height = innerHeight - HEADER_HEIGHT - 11
    const width = 1180 - (20 * 2)

    let teamInvites = []
    if (me.data && me.data.teams[0].invites && teamInvitesDataSource.data) {
      teamInvites = teamInvitesIds.map(id => teamInvitesDataSource.data.byId[id])
    }

    let teamMembers = []
    if (physiciansDataSource.data && !refreshClicked) {
      teamMembers = teamMembersIds.map(id => physiciansDataSource.data.byId[id])
    }
    // THIS IS THE SAME LOGIC COPIED FROM THE PATIENT FILE
    let inboxSettingsInitialValues = {
      custom: {
        ...CUSTOM_TRIGGER_DEFAULT,
      },
      ekgReviewWhichRecordings: ALL_RECORDINGS_TRIGGER_OPTION,
      ekgReviewWhereRecordings: TRIAGE_OPTION,
    }

    const getFormInboxPresets = (triggersById, typeToIdLookup, presets) => {
      const newPresets = {
        ...presets,
      }
      const whichPrimaryTriggerType = Object.keys(PRIMARY_TRIGGER_TYPES).find(triggerType => {
        const id = typeToIdLookup[triggerType]
        return triggersById[id].frequency === TRIGGER_FREQUENCY_TYPES.ALWAYS
      })

      if (whichPrimaryTriggerType) {
        const id = typeToIdLookup[whichPrimaryTriggerType]
        const triggerData = triggersById[id]
        newPresets.ekgReviewWhichRecordings = getPrimaryTriggerOption(whichPrimaryTriggerType, triggerData)
      } else {
        newPresets.ekgReviewWhichRecordings = CUSTOM_TRIGGER_OPTION
        const possibleAFibResultId = typeToIdLookup[TRIGGER_TYPES.POSSIBLE_AFIB_DETECTION]
        if (triggersById[possibleAFibResultId].frequency === TRIGGER_FREQUENCY_TYPES.ALWAYS) {
          newPresets.custom.possibleAFibResultCheckmark = true
        }
        const possibleAFibResultWithHrId = typeToIdLookup[TRIGGER_TYPES.HEART_RATE_OVER_X_AND_AFIB]
        if (triggersById[possibleAFibResultWithHrId].frequency === TRIGGER_FREQUENCY_TYPES.ALWAYS) {
          newPresets.custom.possibleAFibResultWithHrCheckmark = true
          newPresets.custom.possibleAFibResultWithHr = parseInt(triggersById[possibleAFibResultWithHrId].value, 10)
        }
        const allUnclassifiedId = typeToIdLookup[TRIGGER_TYPES.ALL_UNCLASSIFIED]
        if (triggersById[allUnclassifiedId].frequency === TRIGGER_FREQUENCY_TYPES.ALWAYS) {
          newPresets.custom.unclassifiedResultCheckmark = true
        }
        const heartRateUnderId = typeToIdLookup[TRIGGER_TYPES.HEART_RATE_UNDER_X]
        if (triggersById[heartRateUnderId].frequency === TRIGGER_FREQUENCY_TYPES.ALWAYS) {
          newPresets.custom.heartRateUnderCheckmark = true
          newPresets.custom.heartRateUnder = parseInt(triggersById[heartRateUnderId].value, 10)
        }
        const heartRateOverId = typeToIdLookup[TRIGGER_TYPES.HEART_RATE_OVER_X]
        if (triggersById[heartRateOverId].frequency === TRIGGER_FREQUENCY_TYPES.ALWAYS) {
          newPresets.custom.heartRateOverCheckmark = true
          newPresets.custom.heartRateOver = parseInt(triggersById[heartRateOverId].value, 10)
        }
        const bradycardiaId = typeToIdLookup[TRIGGER_TYPES.BRADYCARDIA]
        if (triggersById[bradycardiaId].frequency === TRIGGER_FREQUENCY_TYPES.ALWAYS) {
          newPresets.custom.bradycardia = true
        }
        const tachycardiaId = typeToIdLookup[TRIGGER_TYPES.TACHYCARDIA]
        if (triggersById[tachycardiaId].frequency === TRIGGER_FREQUENCY_TYPES.ALWAYS) {
          newPresets.custom.tachycardia = true
        }
        const sinusRhythmWithPVCsId = typeToIdLookup[TRIGGER_TYPES.SINUS_RHYTHM_PVC]
        if (triggersById[sinusRhythmWithPVCsId].frequency === TRIGGER_FREQUENCY_TYPES.ALWAYS) {
          newPresets.custom.sinusRhythmWithPVCs = true
        }
        const sinusRhythmWithSVEsId = typeToIdLookup[TRIGGER_TYPES.SINUS_RHYTHM_SVE]
        if (triggersById[sinusRhythmWithSVEsId].frequency === TRIGGER_FREQUENCY_TYPES.ALWAYS) {
          newPresets.custom.sinusRhythmWithSVEs = true
        }
        const sinusRhythmWithWideQRSId = typeToIdLookup[TRIGGER_TYPES.SINUS_RHYTHM_WIDE_QRS]
        if (triggersById[sinusRhythmWithWideQRSId].frequency === TRIGGER_FREQUENCY_TYPES.ALWAYS) {
          newPresets.custom.sinusRhythmWithWideQRS = true
        }
      }
      return newPresets
    }

    if (teamTriggersDataSource.data) {
      inboxSettingsInitialValues = {
        ...inboxSettingsInitialValues,
        ...getFormInboxPresets(teamTriggersDataSource.data.byId, teamTriggersDataSource.data.typeToIdLookup, inboxSettingsInitialValues),
      }
    }

    let teamInvitesTableHeight = teamInvites.length > 0
      ? (TEAM_INVITES_ROW_HEIGHT * teamInvites.length)
      : (TEAM_INVITES_ROW_HEIGHT * 5)
    teamInvitesTableHeight += TABLE_HEADER_HEIGHT

    let isAdmin = false
    if (me.data) {
      const { isAdmin: adminPermission } = me.data.profile.permissions
      isAdmin = adminPermission
    }

    // For modifying the values of country & region acc. to requiremnt
    const cleanValues = value => {
      const region = value && value.regions && value.regions[0]
      const smallArray = value && value.regions && [ ...value.regions ]
      let memberArray

      if (smallArray && smallArray.length > 1) {
        const arrayChange = smallArray.shift()
        memberArray = smallArray.map((item, i) => (
          {
            country: 'US',
            region: item,
          }
        ))
      }

      const countryTem = {
        region,
        members: memberArray,
        // members: [ {
        //   Country: 'US',
        //   Region: 'NEVEDA1',
        // } ],
      }

      const tempValue = { ...countryTem, ...value }
      const newProfile = {
        ...tempValue,
      }
      return newProfile
    }
    
    let physician
    let initialValues
    if (memberInfo.data) {
      physician = memberInfo.data
      initialValues = cleanValues(physician)
    }

    const TKFeatureEnabled = checkTKFeatureEnabled(me)

    return (
      <div data-page="settings" className={styles.settings}>
        <ContentHeader
          isLoading={dataIsFetching}
          lastUpdated={dataLastUpdated}
          handleOnRefreshClick={handleOnRefreshClick}
          hasTabs={isAdmin}
          showAddPatient={false}
          text="Settings"
          me={me}
        />

        <PageTabs>
          {
            TKFeatureEnabled && me.data && me.data.profile.permissions.isAdmin ?
            <PageTab
            isActive={selectedPageTab === SETTINGS_PAGE_TABS.UPDATE_PASSWORD}
            handleOnClick={() => handleOnTabClick(SETTINGS_PAGE_TABS.UPDATE_PASSWORD)}
            label={TKFeatureEnabled ? `My Info` : `Update Password`}
          /> : ''
          }
          
          {isAdmin
            && (
              <React.Fragment>
                <PageTab
                  isActive={selectedPageTab === SETTINGS_PAGE_TABS.INVITE_TEAM_MEMBER}
                  handleOnClick={() => handleOnTabClick(SETTINGS_PAGE_TABS.INVITE_TEAM_MEMBER)}
                  label="Invite Member"
                />
                <PageTab
                  isActive={selectedPageTab === SETTINGS_PAGE_TABS.TEAM_MEMBERS}
                  handleOnClick={() => handleOnTabClick(SETTINGS_PAGE_TABS.TEAM_MEMBERS)}
                  label="Team Members"
                />
                {checkRpmFeatureEnabled(me) && !TKFeatureEnabled && (
                  <PageTab
                    isActive={selectedPageTab === SETTINGS_PAGE_TABS.INBOX_SETTINGS}
                    handleOnClick={() => handleOnTabClick(SETTINGS_PAGE_TABS.INBOX_SETTINGS)}
                    label="Inbox Settings"
                  />
                )}
                {TKFeatureEnabled && (
                  <PageTab
                    isActive={selectedPageTab === SETTINGS_PAGE_TABS.TEAM_SETTINGS}
                    handleOnClick={() => handleOnTabClick(SETTINGS_PAGE_TABS.TEAM_SETTINGS)}
                    label="Team Settings"
                  />
                )}
              </React.Fragment>
            )}
        </PageTabs>

        {selectedPageTab === SETTINGS_PAGE_TABS.UPDATE_PASSWORD &&
          <div
            className={styles.formWrapper}
            style={{
              height,
            }}
          >
            <div className={styles.formTop}>
              <h2 className={styles.formTitle}>{!TKFeatureEnabled && `Update Password`}</h2>
              <UpdatePasswordForm
                handleInputChange={handleUpdatePasswordChange}
                handleNotificationChange={handleAppointmentNotificationsChange}
                onSubmit={submitUpdatePassword}
                isSubmitting={pwIsFetching}
                pwError={pwError}
                pwErrorMsg={pwErrorMsg}
                validationTests={validationTests}
                me={me}
                getAppointmentNotificationsSettings={getAppointmentNotificationsSettings}
                getMemberInfo={getTeamMemberFileData}
                onInfoSubmit={handleOnEditTeamMemberSubmit}
                initialValues={initialValues}
                memberOnChangeInfo={memberOnChangeInfo}
              />
            </div>
          </div>
        }

        {selectedPageTab === SETTINGS_PAGE_TABS.INVITE_TEAM_MEMBER
          && ((dataIsFetching && (!me.data || (me.data && !me.data.teams[0].invites))) || refreshClicked) && (
            <div
              className={styles.contentWrapper}
              style={{
                height,
              }}
            >
              <EcgLoader />
            </div>
          )}

        {selectedPageTab === SETTINGS_PAGE_TABS.INVITE_TEAM_MEMBER
          && !((dataIsFetching && (!me.data || (me.data && !me.data.teams[0].invites))) || refreshClicked) && (
            <div
              className={styles.formWrapper}
              style={{
                height,
              }}
            >
              <div className={styles.formTop}>
                <h2 className={styles.formTitle}>Member Information</h2>
                <h3 className={styles.formSubtitle}>When you add a team member to your practice, we will send an invite email to the email address provided.</h3>
                <NewMemberForm
                  onSubmit={handleOnInviteSubmit}
                  isSubmitting={dataIsFetching}
                  showTKFeatureEnabled={TKFeatureEnabled}
                  inviteMemberFormValues={inviteMemberFormValues}
                />
              </div>
              <div className={styles.formTop}>
                <h2 className={styles.formTitle}>Pending Invites</h2>
                <div
                  className={styles.revokeSection}
                  style={{
                    height: teamInvitesTableHeight,
                  }}
                >
                  <TeamInvitesTable
                    data={teamInvites}
                    showRowSelection={true}
                    selected={selectedTeamInvites}
                    onSelectionClick={handleOnSelectionClick}
                    height={height}
                    width={width - (30 * 2)}
                    sortBy={teamInvitesSortBy}
                    sortDirection={teamInvitesSortDirection}
                    rowHeight={TEAM_INVITES_ROW_HEIGHT}
                    filterEmail={selectedTeamInvitesEmail}
                    handleOnFilterButtonClick={handleOnFilterButtonClick}
                    handleOnFilterChange={handleOnTeamInvitesFilterChange}
                    handleOnSortClick={handleOnTeamInvitesSortClick}
                    handleOnOutsidePopoverClick={() => handleOnFilterButtonClick(null)}
                    handleOnBulkAction={handleOnTeamInvitesBulkAction}
                    handleOnBulkActionClearSelection={() => handleOnSelectionClick({})}
                    handleOnPopoverKeyUp={e => {
                      const enterKeyCode = 13
                      if (typeof handleOnFilterButtonClick === 'function' && e.keyCode === enterKeyCode) {
                        handleOnFilterButtonClick(null)
                      }
                    }}
                    bulkActionComplete={bulkActionComplete}
                    bulkActionIsFetching={bulkActionIsFetching}
                    selectedPopover={selectedPopover}
                    selectedEmail={selectedTeamInvitesEmail}
                  />
                </div>
              </div>
            </div>
          )
        }

        {selectedPageTab === SETTINGS_PAGE_TABS.TEAM_MEMBERS &&
          <div
            style={{
              height,
            }}
          >
            <TeamMembersTable
              enableLoader={teamMembersIds.length === 0 || refreshClicked}
              showLoader={dataIsFetching}
              data={teamMembers}
              showRowSelection={false}
              selected={selectedTeamMembers}
              onSelectionClick={updateSelectedTeamMembers}
              height={height}
              width={width}
              onRowClick={handleOnTeamMemberRowClick}
              selectedIndex={selectedIndex}
              sortBy={teamMembersSortBy}
              sortDirection={teamMembersSortDirection}
              filterName={selectedTeamMembersId}
              filterEmail={selectedTeamMembersEmail}
              filterAdminPermission={selectedTeamMembersAdminPermissionId}
              filterPhysicianPermission={selectedTeamMembersPhysicianPermissionId}
              handleOnFilterButtonClick={handleOnFilterButtonClick}
              handleOnFilterChange={handleOnTeamMembersFilterChange}
              handleOnSortClick={handleOnTeamMembersSortClick}
              handleOnOutsidePopoverClick={() => handleOnFilterButtonClick(null)}
              // handleOnBulkAction={handleOnTeamMembersBulkAction}
              handleOnPopoverKeyUp={e => {
                const enterKeyCode = 13
                if (typeof handleOnFilterButtonClick === 'function' && e.keyCode === enterKeyCode) {
                  handleOnFilterButtonClick(null)
                }
              }}
              selectedPopover={selectedPopover}
              physicians={physiciansDataSource}
              selectedId={selectedTeamMembersId}
              selectedEmail={selectedTeamMembersEmail}
              permissionOptions={getPermissionOptions().slice(1)}
              selectedAdminPermissionId={selectedTeamMembersAdminPermissionId}
              selectedPhysicianPermissionId={selectedTeamMembersPhysicianPermissionId}
              handleOnClickTeamMeamber={handleOnTabClick}
              handleOnEditTeamMember={handleOnEditTeamMember}
              showTKFeatureEnabled={TKFeatureEnabled}
              me={me}
            />
          </div>
        }

        {selectedPageTab === SETTINGS_PAGE_TABS.INBOX_SETTINGS &&
          <div
            className={styles.formWrapper}
            style={{
              height,
            }}
          >
            <div className={styles.formTop}>
              <h2 className={styles.formTitle}>Team Inbox Settings</h2>
              <InboxSettingsForm
                onSubmit={handleInboxSettingsForm}
                triggers={teamTriggersDataSource}
                inboxSettingsFormData={inboxSettingsFormData}
                initialValues={inboxSettingsInitialValues}
                isSubmitting={!inboxSettingsFormPristine && (teamTriggersDataSource.isFetching || dataIsFetching)}
              />
            </div>
          </div>
        }
        {selectedPageTab === SETTINGS_PAGE_TABS.TEAM_SETTINGS &&
          <div
            className={styles.formWrapper}
            style={{
              height,
            }}
          >
            <div className={styles.formTop}>
                <TeamSettingsForm/>
            </div>
          </div>
        }
      </div>
    )
  }
}

export default Settings



// WEBPACK FOOTER //
// ./src/legacy/pages/Settings/Settings.jsx